import { ReactNode } from 'react';

interface StatCardProps {
  title: string | ReactNode;
  value: string | number;
  trend: number;
  icon: React.ReactNode;
  loading?: boolean;
  description?: string;
}

export default function StatCard({ title, value, trend, icon, loading = false, description }: StatCardProps) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-gray-500 dark:text-gray-400">
            {icon}
          </span>
          <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {title}
          </h3>
        </div>
        <span className={`text-xs font-medium ${
          trend > 0 ? 'text-green-600 dark:text-green-400' : 
          trend < 0 ? 'text-red-600 dark:text-red-400' : 
          'text-gray-600 dark:text-gray-400'
        }`}>
          {trend > 0 ? '+' : ''}{trend}%
        </span>
      </div>
      <div className="mt-2">
        {loading ? (
          <div className="animate-pulse">
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
          </div>
        ) : (
          <div>
            <p className="text-2xl font-semibold text-gray-900 dark:text-white">
              {value.toString()}
            </p>
            {description && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                {description}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export type { StatCardProps }; 